import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import { translator } from "../../utils/Translator";
import CloseIcon from "@material-ui/icons/Close";
import { Input } from "reactstrap";
import {
  Box,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { Add, Remove } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import Swal from "sweetalert2";

import MainButton from "../UIElements/MainButton";

import ProductSelectorFilter from "./ProductSelectorFilter";
import ProductList from "./ProductList";
import DiscountList from "./DiscountList";
import DialogProductDiscountForm from "./DialogProductDiscountForm";
import DialogCheckStock from "./DialogCheckStock";
import DialogCheckPrice from "./DialogCheckPrice";

import NumberInput from "../FormElements/NumberInput";
import SelectInput from "../FormElements/SelectInput";
import { set } from "nprogress";
import { is } from "@amcharts/amcharts4/core";

const useStyles = makeStyles((theme) => ({
  activeItem: {
    backgroundColor: "#ffe0b2",
  },
  actionButton: {
    border: "1px solid orange",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    "& svg": {
      color: "orange",
    },
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    fontSize: 12,
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>

      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    paddingBottom: 80, // เพิ่ม padding ด้านล่างเพื่อไม่ให้ content ถูกบังโดย sticky footer
    // เพิ่ม styles สำหรับ KeyboardDatePicker
    "& .MuiFormControl-marginNormal": {
      marginTop: "0 !important",
      marginBottom: "0 !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 14px",
    },
    "& .MuiInputBase-input": {
      padding: "10px 14px",
    },
  },
}))(MuiDialogContent);

// Styled component สำหรับ Sticky Action Bar
const StickyActionBar = withStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "#fff",
    borderTop: "1px solid #e0e0e0",
    padding: "12px 24px",
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.15)",
    zIndex: 1301, // สูงกว่า Dialog (1300)
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px",
    width: "100%",
    maxWidth: 1280, // lg size ของ Dialog
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
}))(({ classes, children }) => <div className={classes.root}>{children}</div>);

// Menu_ID ของแต่ละเอกสาร ใช้ตรวจสิทธิ์ให้ตรงกับเอกสารที่เปิดอยู่จริง
const PERMISSION_MENU_ID_BY_DOC_TYPE = {
  DOC_SPO: 109, // SupplierPO
  DOC_SRT: 110, // Supplier Return
  DOC_SREC: 112, // Supplier Receive
  DOC_WDT: 115, // Withdrawtransaction
  DOC_ORDER: 114, // ใบสั่งขาย
};

// ActionCode ที่ใช้คุมการมองเห็นตัวเลขเงินของแต่ละเอกสาร
// UNC = ต้นทุนสินค้า (เอกสารฝั่งซื้อ/เบิก), UNP = ราคาขาย (ใบสั่งขาย)
const PERMISSION_ACTION_BY_DOC_TYPE = {
  DOC_SPO: "UNC",
  DOC_SRT: "UNC",
  DOC_SREC: "UNC",
  DOC_WDT: "UNC",
  DOC_ORDER: "UNP",
};

const DialogProductSelectorForm = (props) => {
  const {
    docType,
    customer = {},
    customerShipTo = "",
    shipToDate = null,
    open,
    action,
    editData = null,
    warehouse = null,
    whsLocation = null,
    invNumber: defaultInvNumber = null,
    invDate: defaultInvDate = null,
    supInvoiceRef: defaultSupInvoiceRef = null,
    isQuantityOnlyMode = false, // โหมดแก้ไขเฉพาะจำนวนสินค้า
    onCloseDialog,
    salesman 
  } = props;

  console.log("editData:", props);

  const classes = useStyles();

  const { authUser } = useSelector(({ auth }) => auth);
  const { languageSelected } = useSelector(({ settings }) => settings);
  const { translate } = useSelector(({ i18n }) => i18n);

  const [loading] = useState(false);
  const [productSelected, setProductSelected] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  const [units, setUnits] = useState([]);
  const [quantities, setQuantities] = useState([]);
  const [productPrice, setProductPrice] = useState([]);
  const [pricesBeforeFree, setPricesBeforeFree] = useState([]); // เก็บราคาก่อน toggle สินค้าแถม
  const [remark, setRemark] = useState("");
  const [lotNo, setLotNo] = useState("");
  const [mfgDateSelected, setMfgDateSelected] = useState(null);
  const [expDateSelected, setExpDateSelected] = useState(null);

  const [shipDateSelected, setShipDateSelected] = useState(
    shipToDate || moment().format("YYYY-MM-DD")
  );
  const [shipToList, setShipToList] = useState([]);
  const [shipToSelected, setShipToSelected] = useState(customerShipTo || "");

  const [warehouseList, setWarehouseList] = useState([]);
  const [warehouseSelected, setWarehouseSelected] = useState("");

  const [whsLocationList, setWhsLocationList] = useState([]);
  const [whsLocationSelected, setWhsLocationSelected] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [supplierReceiveRef, setSupplierReceiveRef] = useState("");
  const [supInvoiceRef, setSupInvoiceRef] = useState("");
  const [invNumber, setInvNumber] = useState("");
  const [invDateSelected, setInvDateSelected] = useState(null);

  const [totalSum, setTotalSum] = useState(0.0);
  const [totalDiscount, setTotalDiscount] = useState(0.0);
  const [grandTotal, setGrandTotal] = useState(0.0);
  const [isFreeItem, setIsFreeItem] = useState(false);

  // เก็บข้อมูลโปรโมชั่น/กิจกรรม สำหรับตรวจสอบว่าเป็นสินค้าจากโปรโมชั่นหรือไม่
  const [itemPromotionCode, setItemPromotionCode] = useState("");
  const [itemPromotionName, setItemPromotionName] = useState("");
  const [productSetCode, setProductSetCode] = useState("");
  const [productSetName, setProductSetName] = useState("");
  const [highestUnitPrice, setHighestUnitPrice] = useState(0);
  const [salesAgreementNumber, setSalesAgreementNumber] = useState("");
  const [itemDepartmentCode, setItemDepartmentCode] = useState("");

  const [isShowFreeItem, setIsShowFreeItem] = useState(false);
  const [isShowCheckPrice, setIsShowCheckPrice] = useState(false);
  const [isShowCheckStock, setIsShowCheckStock] = useState(false);
  const [isStockCount, setIsStockCount] = useState(false);
  const [isShowShipTo, setIsShowShipTo] = useState(false);
  const [isShowPONumber, setIsShowPONumber] = useState(false);
  const [isShowSRECNumber, setIsShowSRECNumber] = useState(false);

  const [isShowInvNumber, setIsShowInvNumber] = useState(false);
  const [isShowSupInvNumber, setIsShowSupInvNumber] = useState(false);
  const [isShowInvDate, setIsShowInvDate] = useState(false);
  const [isShowDiscount, setIsShowDiscount] = useState(false);
  const [isShowWarehouse, setIsShowWarehouse] = useState(false);
  const [isShowWhsLocation, setIsShowWhsLocation] = useState(false);

  const [openDiscountDialog, setOpenDiscountDialog] = useState(false);
  const [discountAction, setDiscountAction] = useState("add");
  const [editDiscountData, setEditDiscountData] = useState(null);

  const [openCheckStockDialog, setOpenCheckStockDialog] = useState(false);
  const [openCheckPriceDialog, setOpenCheckPriceDialog] = useState(false);

  // Discount management states
  const [discounts, setDiscounts] = useState([]);

  // จดจำสินค้าเดิมและข้อมูลที่จะแก้ไข (สำหรับ edit mode)
  const [originalProduct, setOriginalProduct] = useState(null);
  const [originalFormData, setOriginalFormData] = useState(null);

  // Permission states
  const [dataPermission, setDataPermission] = useState([]);
  const [hasPricePermission, setHasPricePermission] = useState(false);

  // ซ่อนตัวเลขเงินเมื่อเอกสารนี้ตรวจสิทธิ์อยู่ (UNC หรือ UNP แล้วแต่เอกสาร) แต่ผู้ใช้ไม่มีสิทธิ์
  // (เอกสารที่ไม่ได้อยู่ใน PERMISSION_MENU_ID_BY_DOC_TYPE จะไม่ถูกกระทบ)
  const hidePriceByPermission =
    PERMISSION_MENU_ID_BY_DOC_TYPE[docType] != null && !hasPricePermission;

  // ใบเบิก (DOC_WDT): ผู้ที่มีสิทธิ์ UNC ดูต้นทุนได้ แต่แก้ไขไม่ได้ เพราะแก้แล้วไม่มีผลกับเอกสาร
  // (เอกสารประเภทอื่นที่ใช้ dialog นี้ร่วมกันจะไม่ถูกกระทบ)
  const isCostReadOnly = docType === "DOC_WDT";

  // Callback สำหรับรับ filter data (ใช้ useCallback เพื่อไม่ให้ reference เปลี่ยน)
  const handleFilterChange = React.useCallback((filterData) => {
    setFilterData(filterData);
  }, []);

  const fetchCustomerShipToList = async () => {
    const params = {
      company: authUser.company !== "#" ? authUser.company : "",
      salesmanCode: authUser.salesman !== "#" ? authUser.salesman : "",
      customerCode: customer.CustomerCode || "",
      language: languageSelected.id,
    };

    const url = `${process.env.REACT_APP_API_URL}customer/customerShipTo`;
    const config = {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("x-access-token")}`,
      },
    };

    try {
      const response = await axios.get(url, config);
      const items = response.data;

      console.log("🚚 Customer Ship-To List fetched:", items);

      // แปลงข้อมูล JSON เป็น { value, label }
      const formattedOptions = items.data.map((item) => ({
        value: item.CustomerCode,
        label: `${item.CustomerName} (${item.CustomerCode}) - ${item.Address}`,
      }));

      setShipToList(formattedOptions);
    } catch (error) {
      console.error("Error fetching customer list:", error);
    } finally {
    }
  };

  const fetchWarehouseList = async () => {
    const params = {
      company: authUser.company !== "#" ? authUser.company : "",
      salesmanCode:
        authUser.salesman !== "#" && authUser.userType !== "web"
          ? authUser.salesman
          : "",
      language: languageSelected.id,
    };

    const url = `${process.env.REACT_APP_API_URL}plant/warehouse`;
    const config = {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("x-access-token")}`,
      },
    };

    try {
      const response = await axios.get(url, config);
      const items = response.data;

      // แปลงข้อมูล JSON เป็น { value, label }
      const formattedOptions = items.data.map((item) => ({
        value: item.PlantNo,
        label: `${item.PlantDescription} (${item.PlantNo})`,
      }));

      setWarehouseList(formattedOptions);
    } catch (error) {
      console.error("Error fetching warehouse list:", error);
    } finally {
    }
  };

  // Helper function to fetch warehouse location by plantNo
  const fetchWarehouseLocationListByPlantNo = async (plantNo) => {
    setWhsLocationSelected("");

    const params = {
      company: authUser.company !== "#" ? authUser.company : "",
      plantNo: plantNo || "",
      language: languageSelected.id,
    };

    console.log("fetchWarehouseLocationListByPlantNo params:::", params);

    const url = `${process.env.REACT_APP_API_URL}plant/warehouseLocation`;
    const config = {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("x-access-token")}`,
      },
    };

    try {
      const response = await axios.get(url, config);
      const items = response.data;

      // แปลงข้อมูล JSON เป็น { value, label }
      const formattedOptions = items.data.map((item) => ({
        value: item.WhsLocation,
        label: `${item.Description} (${item.WhsLocation})`,
      }));

      setWhsLocationList(formattedOptions);
    } catch (error) {
      console.error("Error fetching warehouse location list:", error);
    } finally {
    }
  };

  // ตั้งค่า state ตาม docType
  useEffect(() => {
    if (
      docType === "DOC_ORDER" ||
      docType === "DOC_QUOTATION" ||
      docType === "DOC_RETURN"
    ) {
      setIsShowFreeItem(true);
      setIsShowCheckPrice(true);
      setIsShowCheckStock(true);
      setIsStockCount(false);
      setIsShowShipTo(true);
      setIsShowDiscount(true);
      setIsShowPONumber(false);
      setIsShowInvNumber(false);
      setIsShowInvDate(false);
      setIsShowWarehouse(false);
      setIsShowWhsLocation(false);
    } else if (docType === "DOC_STC") {
      setIsShowFreeItem(false);
      setIsShowCheckPrice(false);
      setIsShowCheckStock(false);
      setIsStockCount(true);
      setIsShowShipTo(false);
      setIsShowDiscount(false);
      setIsShowPONumber(false);
      setIsShowInvNumber(false);
      setIsShowInvDate(false);
      setIsShowWarehouse(false);
      setIsShowWhsLocation(false);
    } else if (docType === "DOC_SREC") {
      setIsShowFreeItem(true);
      setIsShowCheckPrice(false);
      setIsShowCheckStock(true);
      setIsShowShipTo(false);
      setIsShowDiscount(false);
      setIsShowPONumber(true);
      setIsShowInvNumber(true);
      setIsShowInvDate(true);
      setIsShowWarehouse(true);
      setIsShowWhsLocation(true);
    } else if (docType === "DOC_SRT") {
      setIsShowFreeItem(true);
      setIsShowCheckPrice(false);
      setIsShowCheckStock(true);
      setIsShowShipTo(false);
      setIsShowDiscount(false);
      setIsShowSRECNumber(true);
      setIsShowSupInvNumber(true);
      setIsShowInvDate(true);
      setIsShowWarehouse(false);
      setIsShowWhsLocation(false);
    } else if (docType === "DOC_SPO") {
      setIsShowFreeItem(true);
      setIsShowCheckPrice(false);
      setIsShowCheckStock(true);
      setIsStockCount(false);
      setIsShowShipTo(false);
      setIsShowDiscount(false);
      setIsShowPONumber(false);
      setIsShowInvNumber(false);
      setIsShowInvDate(false);
      setIsShowSRECNumber(false);
      setIsShowSupInvNumber(true);
      setIsShowWarehouse(true);
      setIsShowWhsLocation(true);
    }

    else if (docType === "DOC_SPR") {
      setIsShowFreeItem(true);
      setIsShowCheckPrice(false);
      setIsShowCheckStock(true);
      setIsStockCount(false);
      setIsShowShipTo(false);
      setIsShowDiscount(false);
      setIsShowPONumber(false);
      setIsShowInvNumber(false);
      setIsShowInvDate(false);
      setIsShowSRECNumber(false);
      setIsShowSupInvNumber(true);
      setIsShowWarehouse(true);
      setIsShowWhsLocation(true);
    }

    else if (docType === "DOC_WDT") {
      setIsShowFreeItem(false);
      setIsShowCheckPrice(false);
      setIsShowCheckStock(true);
      setIsStockCount(false);
      setIsShowShipTo(false);
      setIsShowDiscount(false);
      setIsShowPONumber(false);
      setIsShowInvNumber(false);
      setIsShowInvDate(false);
      setIsShowSRECNumber(false);
      setIsShowSupInvNumber(false);
      setIsShowWarehouse(true);
      setIsShowWhsLocation(true);
    }



  }, [docType]);

  // เมื่อ isFreeItem เปลี่ยนค่า → set จำนวนเป็น 0
  useEffect(() => {
    if (customer && Object.keys(customer).length > 0) {
      fetchCustomerShipToList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer, languageSelected]);

  useEffect(() => {
    fetchWarehouseList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageSelected]);

  // Fetch permission data (menuID ต้องตรงกับเอกสารที่เปิดอยู่ ไม่ใช่ hardcode เมนูเดียว)
  useEffect(() => {
    const fetchPermission = async () => {
      const menuID = PERMISSION_MENU_ID_BY_DOC_TYPE[docType];
      if (!menuID) return;

      try {
        const params = {
          menuID,
          language: languageSelected.id,
          company: authUser.company !== "#" ? authUser.company : "",
          salesmanCode: authUser.salesman !== "#" ? authUser.salesman : "",
          username: authUser.username,
          calType: authUser.calendarType,
        };

        const url = `${process.env.REACT_APP_API_URL}menu-permission/checkPermission`;
        const config = {
          params,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("x-access-token")}`,
          },
        };

        const response = await axios.get(url, config);
        if (response.data && response.data.data) {
          setDataPermission(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching permission:", error);
      }
    };

    if (open && authUser && languageSelected) {
      fetchPermission();
    }
  }, [open, authUser, languageSelected, docType]);

  // ตรวจสิทธิ์ดูตัวเลขเงินตาม ActionCode ของเอกสารที่เปิดอยู่ (UNC = ต้นทุน, UNP = ราคาขาย)
  useEffect(() => {
    const actionCode = PERMISSION_ACTION_BY_DOC_TYPE[docType];
    setHasPricePermission(
      actionCode != null &&
        dataPermission.some((item) => item.ActionCode === actionCode),
    );
  }, [dataPermission, docType]);

  // ตั้งค่า default warehouse และ whsLocation จาก props
  useEffect(() => {
    if (warehouse && warehouseList.length > 0) {
      // หา warehouse object ที่ตรงกับ props
      const warehouseObj = warehouseList.find(
        (w) => w.value === warehouse.value || w.value === warehouse
      );
      if (warehouseObj) {
        setWarehouseSelected(warehouseObj);
        // ดึง warehouse location list
        fetchWarehouseLocationListByPlantNo(warehouseObj.value);
      }
    }
  }, [warehouse, warehouseList]);

  // ตั้งค่า default whsLocation จาก props (หลังจาก warehouse location list โหลดเสร็จ)
  useEffect(() => {
    if (whsLocation && whsLocationList.length > 0) {
      // หา whsLocation object ที่ตรงกับ props
      const whsLocationObj = whsLocationList.find(
        (w) => w.value === whsLocation.value || w.value === whsLocation
      );
      if (whsLocationObj) {
        setWhsLocationSelected(whsLocationObj);
      }
    }
  }, [whsLocation, whsLocationList]);

  // ตั้งค่า default invNumber, invDate และ supInvoiceRef จาก props (สำหรับ add mode)
  useEffect(() => {
    if (action === "add" && open) {
      if (defaultInvNumber) {
        setInvNumber(defaultInvNumber);
      }
      if (defaultInvDate) {
        setInvDateSelected(defaultInvDate);
      }
      if (defaultSupInvoiceRef) {
        setSupInvoiceRef(defaultSupInvoiceRef);
      }
    }
  }, [action, open, defaultInvNumber, defaultInvDate, defaultSupInvoiceRef]);

  // Sync shipToDate จาก props
  useEffect(() => {
    if (shipToDate) {
      setShipDateSelected(shipToDate);
    }
  }, [shipToDate]);

  // Sync customerShipTo จาก props (รอให้ shipToList โหลดเสร็จก่อน)
  useEffect(() => {
    console.log("🔍 Sync customerShipTo - Debug:", {
      customerShipTo,
      shipToListLength: shipToList.length,
      shipToList,
    });

    if (customerShipTo && shipToList.length > 0) {
      // ถ้า customerShipTo เป็น object ที่มี CustomerCode
      if (customerShipTo.CustomerCode || customerShipTo.value) {
        const customerCode = customerShipTo.CustomerCode || customerShipTo.value;
        console.log("🔍 Looking for CustomerCode:", customerCode);

        const matchedShipTo = shipToList.find(s => s.value === customerCode);
        if (matchedShipTo) {
          setShipToSelected(matchedShipTo);
          console.log("✅ Default ShipTo set:", matchedShipTo);
        } else {
          console.log("❌ No match found in shipToList for:", customerCode);
        }
      } else if (typeof customerShipTo === 'string') {
        // ถ้าเป็น string ให้ค้นหาจาก value
        const matchedShipTo = shipToList.find(s => s.value === customerShipTo);
        if (matchedShipTo) {
          setShipToSelected(matchedShipTo);
          console.log("✅ Default ShipTo set (string):", matchedShipTo);
        }
      } else {
        // ถ้าเป็น format ที่ถูกต้องอยู่แล้ว (มี value และ label)
        setShipToSelected(customerShipTo);
        console.log("✅ Default ShipTo set (direct):", customerShipTo);
      }
    } else if (customerShipTo && shipToList.length === 0) {
      // ถ้า shipToList ยังไม่ได้ load หรือไม่มีข้อมูล ให้ใช้ customerShipTo โดยตรง
      if (customerShipTo.CustomerCode) {
        // สร้าง object ที่มี format { value, label } จาก customerShipTo
        const defaultShipTo = {
          value: customerShipTo.CustomerCode,
          label: `${customerShipTo.CustomerName} (${customerShipTo.CustomerCode}) - ${customerShipTo.Address || ''}`,
        };
        setShipToSelected(defaultShipTo);
        console.log("✅ Default ShipTo set directly (no list):", defaultShipTo);
      } else if (customerShipTo.value && customerShipTo.label) {
        // ถ้าเป็น format ที่ถูกต้องอยู่แล้ว
        setShipToSelected(customerShipTo);
        console.log("✅ Default ShipTo set directly (formatted):", customerShipTo);
      }
    }
  }, [customerShipTo, shipToList]);

  // เวลา productSelected เปลี่ยนค่า → update units + quantities
  useEffect(() => {
    if (productSelected) {
      // ✅ เช็คว่าต้องใช้ Cost หรือ Price (สำหรับเอกสารรับสินค้า/โอนย้าย ใช้ Cost)
      const useCostPrice = docType === 'DOC_SREC' || docType === 'DOC_SPO' || docType === 'DOC_SRT' || docType === 'DOC_WDT';
      
      const newUnits = [
        {
          label: productSelected?.Unit1,
          qty: parseInt(productSelected?.Quantity1 || 0),
          price: parseFloat(useCostPrice ? (productSelected?.Cost1 || 0) : (productSelected?.Price1 || 0)),
        },
        {
          label: productSelected?.Unit2,
          qty: parseInt(productSelected?.Quantity2 || 0),
          price: parseFloat(useCostPrice ? (productSelected?.Cost2 || 0) : (productSelected?.Price2 || 0)),
        },
        {
          label: productSelected?.Unit3,
          qty: parseInt(productSelected?.Quantity3 || 0),
          price: parseFloat(useCostPrice ? (productSelected?.Cost3 || 0) : (productSelected?.Price3 || 0)),
        },
        {
          label: productSelected?.Unit4,
          qty: parseInt(productSelected?.Quantity4 || 0),
          price: parseFloat(useCostPrice ? (productSelected?.Cost4 || 0) : (productSelected?.Price4 || 0)),
        },
      ].filter(
        (u) =>
          u.label &&
          u.label !== "" &&
          u.label !== null &&
          u.label !== "Undefined" &&
          u.label !== "UNDEFINE"
      );

      setUnits(newUnits);

      // ถ้าไม่ได้อยู่ใน edit mode ให้ reset quantities และ prices
      // (เพราะถ้าเป็น edit mode จะมี useEffect อื่นมา set ค่าจาก editData)
      if (action !== "edit") {
        setQuantities(newUnits.map(() => 0));
        setProductPrice(newUnits.map((u) => u.price));
        setIsFreeItem(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSelected]);

  // เมื่อ isFreeItem เปลี่ยนค่า → set ราคาเป็น 0 (แต่ยังแก้จำนวนได้)
  useEffect(() => {
    if (isFreeItem) {
      // เก็บราคาปัจจุบันก่อน set เป็น 0
      setPricesBeforeFree([...productPrice]);
      setProductPrice(units.map(() => 0));
    } else {
      // ถ้าไม่ใช่สินค้าแถม ให้กลับไปใช้ราคาที่เก็บไว้ (ถ้ามี) หรือราคา master
      if (pricesBeforeFree.length > 0) {
        setProductPrice(pricesBeforeFree);
      } else {
        setProductPrice(units.map((u) => u.price));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFreeItem]);

  // คำนวณ totalPrice ทุกครั้งที่ quantities หรือ productPrice เปลี่ยน
  useEffect(() => {
    const total = quantities.reduce((sum, qty, index) => {
      const price = productPrice[index] || 0;
      return sum + qty * price;
    }, 0);

    // ถ้าเป็นสินค้าแถม ไม่คิดส่วนลด
    const discount = isFreeItem ? 0 : calculateDiscount(total, discounts);

    setTotalSum(total);
    setTotalDiscount(discount);
    setGrandTotal(total - discount);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantities, productPrice, isFreeItem, discounts]);

  // useEffect สำหรับ populate ข้อมูลเมื่ออยู่ใน edit mode
  useEffect(() => {
    if (action === "edit" && editData && open) {
      console.log(" Edit mode - Loading editData:", editData);

      //  ตั้งค่าสินค้าทันที (จะทำให้แสดงชื่อสินค้าทันที)
      if (editData.product) {
        setProductSelected(editData.product);
        console.log(" Product set:", editData.product);
      } else if (
        editData.productCode &&
        editData.productName &&
        editData.items
      ) {
        // ถ้าไม่มี product object ให้สร้าง mock product จาก editData.items
        // สร้าง units ทั้งหมดจาก items ที่มี
        const mockProduct = {
          ProductCode: editData.productCode,
          ProductName: editData.productName,
        };

        // สร้าง Unit1-4 จาก items
        editData.items.forEach((item, index) => {
          if (index < 4) {
            // รองรับสูงสุด 4 units
            const unitNum = index + 1;
            mockProduct[`Unit${unitNum}`] = item.unit;
            mockProduct[`Quantity${unitNum}`] = 1; // ใช้ 1 เป็น conversion rate
            mockProduct[`Price${unitNum}`] = item.price || 0;
          }
        });

        // ถ้ายังไม่มี Unit1 ให้ใช้ค่าเริ่มต้น
        if (!mockProduct.Unit1) {
          mockProduct.Unit1 = translator(translate.ISA_UnitPiece, "ชิ้น");
          mockProduct.Quantity1 = 1;
          mockProduct.Price1 = 0;
        }

        setProductSelected(mockProduct);
        console.log(" Mock product created from items:", mockProduct);
      }

      // ตั้งค่า isFreeItem
      setIsFreeItem(editData.isFreeItem || false);

      // ตั้งค่าข้อมูลโปรโมชั่น/กิจกรรม
      setItemPromotionCode(editData.itemPromotionCode || "");
      setItemPromotionName(editData.itemPromotionName || "");
      setProductSetCode(editData.productSetCode || "");
      setProductSetName(editData.productSetName || "");
      setHighestUnitPrice(editData.highestUnitPrice || 0);
      setSalesAgreementNumber(editData.salesAgreementNumber || "");
      setItemDepartmentCode(editData.itemDepartmentCode || "");

      // ตั้งค่า remark
      setRemark(editData.remark || "");

      // ตั้งค่า shipToDate และ shipTo
      setShipDateSelected(editData.shipToDate || moment().format("YYYY-MM-DD"));
      setShipToSelected(editData.shipTo || "");

      // ตั้งค่า Lot, MFG, EXP (สำหรับ DOC_STC)
      setLotNo(editData.lotNo || "");
      setMfgDateSelected(editData.mfgDate || null);
      setExpDateSelected(editData.expDate || null);

      // ตั้งค่า Supplier Receive Ref, Invoice Number, Invoice Date
      if (docType === "DOC_SRT") {
        setSupplierReceiveRef(
          editData.supplierReceiveRef || editData.poNumber || ""
        );
        setSupInvoiceRef(editData.supInvoiceRef || editData.invNumber || "");
      }

      // ตั้งค่า PO Number, Invoice Number, Invoice Date (สำหรับ DOC_SREC)
      setPoNumber(editData.poNumber || "");
      setInvNumber(editData.invNumber || "");
      setInvDateSelected(editData.invDate || null);

      // ตั้งค่า Warehouse และ WhsLocation (สำหรับ DOC_SREC)
      // Note: จะมี useEffect อีกตัวที่จะโหลดจาก props ถ้าไม่มีใน editData
      if (editData.plantNo) {
        setWarehouseSelected(editData.plantNo);
      }
      if (editData.whsLocation) {
        setWhsLocationSelected(editData.whsLocation);
      }

      //  ปิด initial loading เพราะเป็น edit mode (จะทำให้แสดงฟอร์มทันที)
      setIsInitialLoading(false);

      console.log(" Edit mode setup complete");
    } else if (action === "add" && open) {
      console.log("🆕 Add mode - Resetting form");

      // ถ้าเป็น add mode ให้เปิด initial loading และ reset ทุกอย่าง
      setIsInitialLoading(true);
      setProductSelected(null);
      setIsFreeItem(false);
      setRemark("");
      // ใช้ค่าจาก props แทนการ reset เป็น default
      setShipDateSelected(shipToDate || moment().format("YYYY-MM-DD"));
      setShipToSelected(customerShipTo || "");
      setLotNo("");
      setMfgDateSelected(null);
      setExpDateSelected(null);
      setDiscounts([]);

      // Reset ข้อมูลโปรโมชั่น/กิจกรรม
      setItemPromotionCode("");
      setItemPromotionName("");
      setProductSetCode("");
      setProductSetName("");
      setHighestUnitPrice(false);
      setSalesAgreementNumber("");
      setItemDepartmentCode("");

      setQuantities([]);
      setProductPrice([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action, editData, open]);

  // useEffect สำหรับจดจำข้อมูลเดิมในโหมด edit
  useEffect(() => {
    if (open && action === "edit" && editData && editData.product) {
      setOriginalProduct(editData.product);

      // จดจำข้อมูล form เดิม
      setOriginalFormData({
        quantities: editData.items
          ? editData.items.map((item) => item.quantity)
          : [],
        prices: editData.items ? editData.items.map((item) => item.price) : [],
        discounts: editData.discounts || [],
        isFreeItem: editData.isFreeItem || false,
        remark: editData.remark || "",
        shipToDate: editData.shipToDate || moment().format("YYYY-MM-DD"),
        shipTo: editData.shipTo || "",
        lotNo: editData.lotNo || "",
        mfgDate: editData.mfgDate || null,
        expDate: editData.expDate || null,
        poNumber: editData.poNumber || "",
        invNumber: editData.invNumber || "",
        invDate: editData.invDate || null,
        plantNo: editData.plantNo || "",
        plantName: editData.plantName || "",
        whsLocation: editData.whsLocation || "",
        whsLocationName: editData.whsLocationName || "",
        itemPromotionCode: editData.itemPromotionCode || "",
        itemPromotionName: editData.itemPromotionName || "",
        productSetCode: editData.productSetCode || "",
        productSetName: editData.productSetName || "",
        highestUnitPrice: editData.highestUnitPrice || 0,
        salesAgreementNumber: editData.salesAgreementNumber || "",
        itemDepartmentCode: editData.itemDepartmentCode || "",
      });
    } else if (open && action === "add") {
      setOriginalProduct(null);
      setOriginalFormData(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, action, editData]);

  // useEffect สำหรับตั้งค่า quantities และ prices เมื่อ units พร้อมแล้ว (สำหรับ edit mode)
  useEffect(() => {
    if (
      action === "edit" &&
      units.length > 0 &&
      productSelected &&
      originalProduct && editData
    ) {
      console.log("🔧 Setting up quantities and prices for edit mode");
      console.log("🔧 Units:", units);
      console.log("🔧 Edit Data Items:", editData?.items);

      // ถ้าเป็นสินค้าเดิม → ใช้ข้อมูลจาก editData
      if (productSelected.ProductCode === originalProduct.ProductCode) {
        if (editData && editData.items && editData.items.length > 0) {
          const newQuantities = new Array(units.length).fill(0);
          const newPrices = new Array(units.length).fill(0); // เริ่มต้นด้วย 0 ทุก unit

          editData.items.forEach((item) => {
            const unitIndex = units.findIndex((u) => u.label === item.unit);
            console.log(` Finding unit "${item.unit}" - Index: ${unitIndex}`);

            if (unitIndex !== -1) {
              newQuantities[unitIndex] = item.quantity;
              newPrices[unitIndex] = item.price || 0; // เพิ่ม fallback
              console.log(
                ` Set quantity[${unitIndex}] = ${item.quantity}, price = ${item.price}`
              );
            }
          });

          setQuantities(newQuantities);
          setProductPrice(newPrices);

          console.log(" Final Quantities:", newQuantities);
          console.log(" Final Prices:", newPrices);

          //  Set discounts หลังจาก set quantities และ prices แล้ว
          if (editData.discounts && editData.discounts.length > 0) {
            setDiscounts(editData.discounts);
            console.log(" Discounts set:", editData.discounts);
          }
        }
      } else {
        console.log(" Different product - Resetting to defaults");
        // ถ้าเป็นสินค้าอื่น → reset เป็นค่าเริ่มต้น
        setQuantities(units.map(() => 0));
        setProductPrice(units.map((u) => u.price));
        setDiscounts([]);
      }
    } else if (action === "add" && units.length > 0) {
      console.log("🆕 Add mode - Setting default quantities and prices");
      // สำหรับ add mode
      setQuantities(units.map(() => 0));
      setProductPrice(units.map((u) => u.price));
      setDiscounts([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [units, action, productSelected, editData, originalProduct]);

  const calculateDiscount = (total, discounts) => {
    let discountTotal = 0;

    if (total <= 0 || !productSelected) return 0;

    discounts.forEach((d) => {
      if (d.discountType === "P") {
        // สำหรับ % discount คำนวณตามยอดเงินรวม (ไม่ต้องแปลงหน่วย)
        discountTotal += (total * d.discountAmount) / 100;
      } else if (d.discountType === "A" || d.discountType === "Q") {
        // สำหรับ Amount discount ต้องแปลงหน่วยสินค้าให้ตรงกับหน่วยส่วนลด
        const discountQuantityInUnit = getDiscountQuantityInExactUnit(d.unit);
        // คำนวณส่วนลดตามจำนวนในหน่วยที่แปลงแล้ว
        discountTotal += discountQuantityInUnit * d.discountAmount;
      }
    });

    return discountTotal;
  };

  // ฟังก์ชันสำหรับแปลงจำนวนสินค้าเป็นหน่วยเดียวกับส่วนลด (สำหรับ Amount discount)
  const getDiscountQuantityInExactUnit = (discountUnit) => {
    if (!productSelected || !units || !quantities) {
      console.log(" getDiscountQuantityInExactUnit: ข้อมูลไม่ครบ", {
        productSelected,
        units,
        quantities,
      });
      return 0;
    }

    console.log(" Debug getDiscountQuantityInExactUnit:", {
      discountUnit,
      units: units.map((u) => u.label),
      quantities,
    });

    // หาหน่วยของส่วนลดในรายการหน่วยของสินค้า
    const unitIndex = units.findIndex((unit) => unit.label === discountUnit);

    if (unitIndex !== -1) {
      // ถ้าหน่วยตรงกันและมีจำนวน ใช้จำนวนโดยตรง
      const directQuantity = quantities[unitIndex] || 0;
      if (directQuantity > 0) {
        console.log(
          ` หน่วยตรงกันและมีจำนวน (${discountUnit}): ${directQuantity}`
        );
        return directQuantity;
      } else {
        // ถ้าหน่วยตรงกันแต่จำนวนเป็น 0 ให้แปลงจากหน่วยอื่น
        console.log(
          `🔄 หน่วยตรงกันแต่จำนวน 0: ต้องแปลงจากหน่วยอื่น ${discountUnit}`
        );
        return convertToDiscountUnitExact(discountUnit);
      }
    } else {
      // ถ้าหน่วยไม่ตรงกัน ต้องแปลงหน่วยแบบทศนิยม (ไม่ใช้ Math.floor)
      console.log(`🔄 หน่วยไม่ตรงกัน: ต้องแปลง ${discountUnit}`);
      return convertToDiscountUnitExact(discountUnit);
    }
  };

  // ฟังก์ชันแปลงหน่วยสินค้าให้เป็นหน่วยของส่วนลดแบบทศนิยม (สำหรับ Amount discount)
  const convertToDiscountUnitExact = (discountUnit) => {
    if (!productSelected || !units || !quantities) return 0;

    let totalBaseQuantity = 0;

    console.log(" Debug convertToDiscountUnitExact:", {
      discountUnit,
      quantities,
      units: units.map((u) => ({ label: u.label, qty: u.qty })),
    });

    // รวมจำนวนสินค้าทั้งหมดในหน่วยที่เล็กที่สุด (Unit1)
    quantities.forEach((qty, index) => {
      if (qty > 0 && units[index]) {
        // แปลงจำนวนเป็นหน่วยพื้นฐาน
        const baseQty = qty * units[index].qty;
        totalBaseQuantity += baseQty;
        console.log(
          `   ${units[index].label}: ${qty} × ${units[index].qty} = ${baseQty}`
        );
      }
    });

    console.log(` รวมหน่วยพื้นฐาน: ${totalBaseQuantity}`);

    // หาอัตราแปลงของหน่วยส่วนลด
    const discountUnitRate = getUnitConversionRate(discountUnit);
    console.log(`⚙️ อัตราแปลง ${discountUnit}: ${discountUnitRate}`);

    if (discountUnitRate > 0) {
      // แปลงจำนวนพื้นฐานเป็นหน่วยส่วนลดแบบทศนิยม (สำหรับ Amount discount)
      const result = totalBaseQuantity / discountUnitRate;
      console.log(
        `🎯 Result: ${totalBaseQuantity} ÷ ${discountUnitRate} = ${result}`
      );
      return result;
    }

    console.log(" อัตราแปลงเป็น 0 หรือไม่ถูกต้อง");
    return 0;
  };

  // ฟังก์ชันหาอัตราแปลงของหน่วย
  const getUnitConversionRate = (targetUnit) => {
    if (!productSelected) return 0;

    console.log(" Debug getUnitConversionRate:", {
      targetUnit,
      productUnits: {
        Unit1: productSelected.Unit1,
        Unit2: productSelected.Unit2,
        Unit3: productSelected.Unit3,
        Unit4: productSelected.Unit4,
      },
      productQuantities: {
        Quantity1: productSelected.Quantity1,
        Quantity2: productSelected.Quantity2,
        Quantity3: productSelected.Quantity3,
        Quantity4: productSelected.Quantity4,
      },
    });

    // ตรวจสอบหน่วยต่างๆ ของสินค้า
    if (targetUnit === productSelected.Unit1) {
      const rate = parseInt(productSelected.Quantity1 || 1);
      console.log(` Found Unit1 (${targetUnit}): rate = ${rate}`);
      return rate;
    }
    if (targetUnit === productSelected.Unit2) {
      const rate = parseInt(productSelected.Quantity2 || 1);
      console.log(` Found Unit2 (${targetUnit}): rate = ${rate}`);
      return rate;
    }
    if (targetUnit === productSelected.Unit3) {
      const rate = parseInt(productSelected.Quantity3 || 1);
      console.log(` Found Unit3 (${targetUnit}): rate = ${rate}`);
      return rate;
    }
    if (targetUnit === productSelected.Unit4) {
      const rate = parseInt(productSelected.Quantity4 || 1);
      console.log(` Found Unit4 (${targetUnit}): rate = ${rate}`);
      return rate;
    }

    console.log(` ไม่พบหน่วย ${targetUnit} ในสินค้า`);
    return 0;
  };

  // ฟังก์ชันจัดการส่วนลด
  const handleAddDiscount = (discountData) => {
    const newDiscount = {
      ...discountData,
      id: Date.now(), // สร้าง unique ID
    };
    setDiscounts([...discounts, newDiscount]);
    console.log("เพิ่มส่วนลด:", newDiscount);
  };

  const handleEditDiscount = (discountData) => {
    setDiscounts(
      discounts.map((d) => (d.id === discountData.id ? discountData : d))
    );
    console.log("แก้ไขส่วนลด:", discountData);
  };

  const handleDeleteDiscount = (discountId) => {
    setDiscounts(discounts.filter((d) => d.id !== discountId));
    console.log("ลบส่วนลด ID:", discountId);
  };

  const handleOpenDiscountDialogForEdit = (discount) => {
    setDiscountAction("edit");
    setEditDiscountData(discount);
    setOpenDiscountDialog(true);
  };

  const handleProductSelect = (product) => {
    console.log("เลือกสินค้า:", product);

    // ถ้าเป็น edit mode
    if (action === "edit" && originalProduct && originalFormData) {
      // ถ้าเลือกสินค้าเดิม → คืนข้อมูลเดิม
      if (product.ProductCode === originalProduct.ProductCode) {
        setProductSelected(product);

        // คืนค่าข้อมูลเดิม
        setIsFreeItem(originalFormData.isFreeItem);
        setRemark(originalFormData.remark);
        setShipDateSelected(originalFormData.shipToDate);
        setShipToSelected(originalFormData.shipTo);
        setLotNo(originalFormData.lotNo);
        setMfgDateSelected(originalFormData.mfgDate);
        setExpDateSelected(originalFormData.expDate);
        setDiscounts(originalFormData.discounts);

        // คืนค่าข้อมูลโปรโมชั่น/กิจกรรม
        setItemPromotionCode(originalFormData.itemPromotionCode || "");
        setItemPromotionName(originalFormData.itemPromotionName || "");
        setProductSetCode(originalFormData.productSetCode || "");
        setProductSetName(originalFormData.productSetName || "");
        setHighestUnitPrice(originalFormData.highestUnitPrice || 0);
        setSalesAgreementNumber(originalFormData.salesAgreementNumber || "");
        setItemDepartmentCode(originalFormData.itemDepartmentCode || "");

        console.log("กลับมาเลือกสินค้าเดิม - คืนข้อมูลเดิม");
      } else {
        // ถ้าเลือกสินค้าอื่น → reset form
        setProductSelected(product);

        // Reset form เป็นค่าเริ่มต้น
        setIsFreeItem(false);
        setRemark("");
        setShipDateSelected(moment().format("YYYY-MM-DD"));
        setShipToSelected("");
        setLotNo("");
        setMfgDateSelected(null);
        setExpDateSelected(null);
        setDiscounts([]);

        // Reset ข้อมูลโปรโมชั่น/กิจกรรม
        setItemPromotionCode("");
        setItemPromotionName("");
        setProductSetCode("");
        setProductSetName("");
        setHighestUnitPrice(0);
        setSalesAgreementNumber("");
        setItemDepartmentCode("");

        console.log("เลือกสินค้าอื่น - reset form");
      }
    } else {
      // ถ้าเป็น add mode หรือไม่มีข้อมูลเดิม
      setProductSelected(product);
    }

    // เมื่อเลือกสินค้าครั้งแรก ให้ปิด initial loading
    if (isInitialLoading) {
      setIsInitialLoading(false);
    }
  };

  // สำหรับปุ่ม + / -
  const handleQtyChangeButton = (index, change) => {
    // ลบเงื่อนไข isFreeItem ออก เพื่อให้แก้จำนวนได้แม้เป็นสินค้าแถม
    setQuantities((prev) => {
      const newQty = [...prev];
      newQty[index] = Math.max(0, (newQty[index] || 0) + change);
      return newQty;
    });
  };

  // สำหรับ NumberInput
  const handleQtyChange = (index, val) => {
    // ลบเงื่อนไข isFreeItem ออก เพื่อให้แก้จำนวนได้แม้เป็นสินค้าแถม
    setQuantities((prev) => {
      const newQty = [...prev];
      const parsed = parseInt(val) || 0;
      newQty[index] = parsed;
      return newQty;
    });
  };

  const handleProductPriceChange = (index, val) => {
    setProductPrice((prev) => {
      const newPrice = [...prev];
      const parsed = parseFloat(val) || 0;
      newPrice[index] = parsed;
      return newPrice;
    });
  };

  const handleDateChange = (date, type) => {
    if (date && moment(date).isValid()) {
      let newDate = moment(date).format("YYYY-MM-DD");
      if (type === "ship") {
        setShipDateSelected(newDate);
      } else if (type === "mfg") {
        setMfgDateSelected(newDate);
      } else if (type === "exp") {
        setExpDateSelected(newDate);
      } else if (type === "inv") {
        setInvDateSelected(newDate);
      }
    } else {
      if (type === "ship") {
        setShipDateSelected("");
      } else if (type === "mfg") {
        setMfgDateSelected(null);
      } else if (type === "exp") {
        setExpDateSelected(null);
      } else if (type === "inv") {
        setInvDateSelected(null);
      }
    }
  };

  const handleOpenDiscountDialog = () => {
    setDiscountAction("add");
    setEditDiscountData(null);
    setOpenDiscountDialog(true);
  };

  const handleCloseDiscountDialog = (discountData) => {
    if (discountData) {
      if (discountAction === "add") {
        handleAddDiscount(discountData);
      } else if (discountAction === "edit") {
        handleEditDiscount(discountData);
      }
    }

    setOpenDiscountDialog(false);
    setDiscountAction("add");
    setEditDiscountData(null);
  };

  const handleSubmit = () => {
    console.log("🔥 Form submitted with validation passed");

    // สร้าง array สำหรับเก็บ error messages
    const errors = [];

    // Validation: ตรวจสอบเลขที่ Invoice (สำหรับ DOC_SREC)
    if (docType === "DOC_SREC" && (!invNumber || invNumber.trim() === "")) {
      errors.push(translator(translate.ISA_PleaseEnterInvNumber, "กรุณาระบุเลขที่ Invoice"));
    }



    if (docType === "DOC_SRT" && (!invNumber || invNumber.trim() === "")) {
      errors.push(translator(translate.ISA_AUTO_PLEASE_ENTER_SUP_INV_NUMBER, "กรุณาระบุเลขที่ Sup_Invoice"));
    }

    if (docType === "DOC_SRT" && !invDateSelected) {
      errors.push(translator(translate.ISA_AUTO_PLEASE_ENTER_SUP_INV_DATE, "กรุณาระบุวันที่ Sup_Invoice"));
    }

    // Validation: ตรวจสอบวันที่ Invoice (สำหรับ DOC_SREC)
    if (docType === "DOC_SREC" && !invDateSelected) {
      errors.push(translator(translate.ISA_PleaseEnterInvDate, "กรุณาระบุวันที่ Invoice"));
    }

    // Validation: ตรวจสอบเลขที่ Sup Invoice (สำหรับ DOC_SRT)
    // if (
    //   docType === "DOC_SRT" &&
    //   (!supInvoiceRef || supInvoiceRef.trim() === "")
    // ) {
    //   // Sup Invoice validation removed/commented to avoid hardcoded string
    // }

    // Validation: ตรวจสอบว่าเลือกสินค้าหรือยัง
    if (!productSelected) {
      errors.push(translator(translate.ISA_Product, "กรุณาเลือกสินค้าก่อน"));
    }

    // Validation: ตรวจสอบจำนวนสินค้า
    const totalQty = quantities.reduce((sum, qty) => sum + qty, 0);
    if (totalQty === 0) {
      errors.push(translator(translate.ISA_AUTO_PLEASE_ENTER_PRODUCT_QTY, "กรุณาระบุจำนวนสินค้า"));
    }

    // Validation: ตรวจสอบวันที่จัดส่ง (สำหรับ ORDER, QUOTATION, RETURN)
    if (!isStockCount && !shipDateSelected) {
      errors.push(translator(translate.ISA_AUTO_PLEASE_SELECT_SHIP_DATE, "กรุณาเลือกวันที่จัดส่ง"));
    }

    // Validation: ตรวจสอบ Lot, วันที่ผลิต, วันหมดอายุ (สำหรับ Stock Count - DOC_STC)
    if (isStockCount) {
      if (!lotNo || lotNo.trim() === "") {
        errors.push(translator(translate.ISA_AUTO_PLEASE_ENTER_LOT, "กรุณาระบุ Lot"));
      }
      if (!mfgDateSelected) {
        errors.push(translator(translate.ISA_AUTO_PLEASE_ENTER_MFG_DATE, "กรุณาระบุวันที่ผลิต"));
      }
      if (!expDateSelected) {
        errors.push(translator(translate.ISA_AUTO_PLEASE_ENTER_EXP_DATE, "กรุณาระบุวันหมดอายุ"));
      }
    }

    // Validation: ตรวจสอบราคาสินค้า (ยกเว้นกรณี DOC_STC, สินค้าแถม, และ docType ที่ใช้ Cost)
    // เช็คเฉพาะ unit ที่มีจำนวน (quantity > 0) ว่ามีราคาหรือไม่
    // ✅ สำหรับ docType ที่ใช้ Cost (DOC_SREC, DOC_SPO, DOC_SRT, DOC_WDT) อนุญาตให้ Cost = 0 ได้
    const useCostPrice = docType === 'DOC_SREC' || docType === 'DOC_SPO' || docType === 'DOC_SRT' || docType === 'DOC_WDT';
    if (!isStockCount && !isFreeItem && !useCostPrice) {
      const hasInvalidPrice = productPrice.some((price, index) => {
        const qty = quantities[index] || 0;
        return qty > 0 && price <= 0;
      });
      if (hasInvalidPrice) {
        errors.push(translator(translate.ISA_AUTO_PLEASE_ENTER_PRICE, "กรุณาระบุราคาสินค้าให้ถูกต้อง"));
      }
    }

    // ถ้ามี error ให้แสดง SweetAlert2
    if (errors.length > 0) {
      Swal.fire({
        icon: "warning",
        title: translator(translate.ISA_PleaseCheck, "กรุณาตรวจสอบข้อมูล"),
        html: `
                      <div style="text-align: left; padding: 10px;">
                          <p style="margin-bottom: 10px; color: #666;">
                              ${translator(translate.ISA_FillDataBeforeSave, "กรุณากรอกข้อมูลให้ครบถ้วนก่อนบันทึก")}:
                          </p>
                          <div style="background: #fff3e0; padding: 15px; border-radius: 8px; border-left: 4px solid #ff9800;">
                              ${errors.join("<br/>")}
                          </div>
                      </div>
                  `,
        confirmButtonText: translator(translate.ISA_Button_Ok, "ตกลง"),
        confirmButtonColor: "#ff9800",
        customClass: {
          popup: "swal-wide",
          title: "swal-title-custom",
        },
      });
      return;
    }

    console.log(" Debugging handleSubmit:");
    console.log("productSelected:", productSelected);
    console.log("quantities:", quantities);
    console.log("productPrice:", productPrice);
    console.log("shipDateSelected:", shipDateSelected);
    console.log("lotNo:", lotNo);
    console.log("mfgDateSelected:", mfgDateSelected);
    console.log("expDateSelected:", expDateSelected);

    // สร้าง product items จากแต่ละหน่วยนับที่มีจำนวน > 0
    const productItems = units
      .map((unit, index) => ({
        unit: unit.label,
        unitQty: unit.qty,
        quantity: quantities[index],
        price: productPrice[index],
        totalPrice: quantities[index] * productPrice[index],
      }))
      .filter((item) => item.quantity > 0);

    // สร้าง object ที่จะส่งกลับ
    const productData = {
      // Unique identifier (ถ้าเป็น edit ให้ใช้ id เดิม, ถ้าเป็น add ให้สร้างใหม่)
      id: action === "edit" && editData ? editData.id : Date.now(),

      // ข้อมูลสินค้า
      product: productSelected,
      productCode: productSelected.ProductCode,
      productName: productSelected.ProductName,
      items: productItems,
      isFreeItem: isFreeItem,
      remark: remark,

      // ข้อมูลโปรโมชั่น/กิจกรรม
      itemPromotionCode: itemPromotionCode,
      itemPromotionName: itemPromotionName,
      productSetCode: productSetCode,
      productSetName: productSetName,
      highestUnitPrice: highestUnitPrice,
      salesAgreementNumber: salesAgreementNumber,
      itemDepartmentCode: itemDepartmentCode,

      // ส่วนลด
      discounts: !isFreeItem ? discounts : [],

      // ยอดเงิน
      totalSum: totalSum,
      totalDiscount: totalDiscount,
      grandTotal: grandTotal,
      shipToDate: shipDateSelected,
      shipTo: shipToSelected,
      lotNo: lotNo,
      mfgDate: mfgDateSelected,
      expDate: expDateSelected,
      plantNo: warehouseSelected ? warehouseSelected.value : "",
      plantName: warehouseSelected ? warehouseSelected.label : "",
      whsLocation: whsLocationSelected ? whsLocationSelected.value : "",
      whsLocationName: whsLocationSelected ? whsLocationSelected.label : "",
      poNumber: poNumber,
      invNumber: defaultInvNumber || "",
      invDate: defaultInvDate || null,
      supplierReceiveRef: docType === "DOC_SRT" ? supplierReceiveRef : "",
      supInvoiceRef: (docType === "DOC_SRT" || docType === "DOC_SPO" || docType === "DOC_SPR") ? supInvoiceRef : "",
    };

    console.log(" Product Data to return:", productData);

    // ส่งข้อมูลกลับไปหน้าหลัก
    onCloseDialog(productData);

    // Reset จำนวนสินค้าหลังบันทึก (เพื่อให้พร้อมเลือกสินค้าใหม่)
    setQuantities(units.map(() => 0));
    setRemark("");
    setDiscounts([]);
  };

  // ตรวจสอบว่าเป็น docType ที่ใช้ Cost แทน Price
  const useCostPrice = docType === 'DOC_SREC' || docType === 'DOC_SPO' || docType === 'DOC_SRT' || docType === 'DOC_WDT';

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={() => { }}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => onCloseDialog(null)}
        >
          {action === "add"
            ? translator(translate.ISA_AddProduct, "เพิ่มสินค้า")
            : translator(translate.ISA_EditProduct, "แก้ไขสินค้า")}
        </DialogTitle>
        <DialogContent>
          <div className="row">
            <div
              className="col-12 col-sm-4"
              style={{ borderRight: "1px solid #e0e0e0" }}
            >
              <div className="row">
                <div className="col-12">
                  <ProductSelectorFilter
                    onFilterChange={handleFilterChange}
                    isDisabled={isQuantityOnlyMode}
                    docType={docType}
                  />
                </div>
                <div className="col-12">
                  <ProductList
                    onSelect={handleProductSelect}
                    selectedProduct={productSelected}
                    customer={customer}
                    docType={docType}
                    salesman={salesman}
                    filterData={filterData}
                    isDisabled={isQuantityOnlyMode}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-8">
              <h3>
                {translator(
                  translate.ISA_ProductDetailTitle,
                  "รายละเอียดข้อมูลสินค้า"
                )}
              </h3>
              {productSelected ? (
                <Box p={2}>
                  {/* Header */}
                  <Box display="flex" alignItems="center" mb={2}>
                    <img
                      src="https://via.placeholder.com/120" // ถ้ามีรูปจริงเอามาแทนได้
                      alt={productSelected.ProductName}
                      style={{ width: 120, height: 120, borderRadius: 8 }}
                    />
                    <Box ml={2}>
                      <Typography variant="h6">
                        {productSelected.ProductName}
                      </Typography>
                      <Typography color="textSecondary">
                        {productSelected.ProductCode}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Free item checkbox + Buttons */}
                  <Box display="flex" alignItems="center" mt={2}>
                    {isShowFreeItem && (
                      <>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={isFreeItem}
                              onChange={(e) => setIsFreeItem(e.target.checked)}
                              disabled={isQuantityOnlyMode || itemPromotionCode !== "" || productSetCode !== ""}
                            />
                          }
                          label={translator(translate.ISA_FreeItem, "สินค้าแถม")}
                        />
                      </>
                    )}
                    <Box flexGrow={1} />

                    {/* ไม่มีสิทธิ์ดูตัวเลขเงิน = ซ่อนปุ่มเช็คราคา เพราะเปิดไปเห็นตาราง Price1-4 ทั้งหมด */}
                    {isShowCheckPrice && !hidePriceByPermission && (
                      <>
                        <Button
                          variant="outlined"
                          style={{
                            borderColor: "orange",
                            color: "orange",
                            marginRight: 8,
                          }}
                          onClick={() => setOpenCheckPriceDialog(true)}
                          disabled={isQuantityOnlyMode}
                        >
                          {translator(translate.ISA_CheckPrice, "เช็คราคา")}
                        </Button>
                      </>
                    )}
                    {isShowCheckStock && (
                      <>
                        <Button
                          variant="outlined"
                          style={{ borderColor: "orange", color: "orange" }}
                          onClick={() => setOpenCheckStockDialog(true)}
                          disabled={isQuantityOnlyMode}
                        >
                          {translator(translate.ISA_Stock, "สต๊อก")}
                        </Button>
                      </>
                    )}
                  </Box>
                  <Box
                    mt={2}
                    display="grid"
                    gridTemplateColumns="20% 40% 40%"
                    gridGap={16}
                  >
                    <Box>
                      <Typography
                        variant="subtitle2"
                        style={{ fontWeight: "bold" }}
                      >
                        {translator(translate.ISA_UnitName, "หน่วยนับ")}
                      </Typography>
                    </Box>
                    {!isStockCount && (
                      <Box>
                        <Typography
                          variant="subtitle2"
                          style={{ fontWeight: "bold" }}
                        >
                          {translator(
                            useCostPrice ? translate.ISA_Cost : translate.ISA_Price,
                            useCostPrice ? "ต้นทุน" : "ราคา"
                          )}
                        </Typography>
                      </Box>
                    )}
                    <Box>
                      <Typography
                        variant="subtitle2"
                        style={{ fontWeight: "bold" }}
                      >
                        {translator(translate.ISA_Qty, "จำนวน")}
                      </Typography>
                    </Box>
                  </Box>

                  {units.map((unit, index) => (
                    <Box
                      mt={2}
                      display="grid"
                      gridTemplateColumns="20% 40% 40%"
                      gridGap={16}
                    >
                      {/* หน่วยนับ */}
                      <Box>
                        <Box
                          display="flex"
                          alignItems="center"
                          mt={1}
                          key={index}
                        >
                          <Typography
                            variant="subtitle2"
                            style={{ width: 100 }}
                          >
                            {unit.label} : {unit.qty}
                          </Typography>
                        </Box>
                      </Box>

                      {/* ราคา */}
                      {!isStockCount && (
                        <Box>
                          <Box
                            display="flex"
                            alignItems="center"
                            mt={1}
                            key={index}
                          >
                            {hidePriceByPermission ? (
                              <TextField
                                size="small"
                                variant="outlined"
                                fullWidth
                                value={translator(translate.ISA_NoPermissionToAccessData, "ไม่มีสิทธิ์เข้าถึงข้อมูล")}
                                disabled
                                InputProps={{
                                  style: {
                                    backgroundColor: '#f5f5f5',
                                    color: '#9e9e9e',
                                  },
                                }}
                              />
                            ) : (
                              <NumberInput
                                value={productPrice[index]}
                                textAlign="right"
                                disabled={isFreeItem || isQuantityOnlyMode || isCostReadOnly}
                                onChange={(val) =>
                                  handleProductPriceChange(index, val)
                                }
                              />
                            )}
                          </Box>
                        </Box>
                      )}

                      {/* จำนวน */}
                      <Box>
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          sx={{ width: "100%", maxWidth: 280 }}
                        >
                          {/* ปุ่มลบ */}
                          <IconButton
                            size="small"
                            className={classes.actionButton}
                            onClick={() => handleQtyChangeButton(index, -1)}
                          >
                            <Remove />
                          </IconButton>

                          {/* ช่องตัวเลข */}
                          <NumberInput
                            value={quantities[index]}
                            decimalScale={0}
                            textAlign="right"
                            onChange={(val) => handleQtyChange(index, val)}
                          />

                          {/* ปุ่มบวก */}
                          <IconButton
                            size="small"
                            className={classes.actionButton}
                            onClick={() => handleQtyChangeButton(index, 1)}
                          >
                            <Add />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  ))}

                  {/* Detail */}
                  {!isStockCount && (
                    <>
                      <Box
                        mt={5}
                        display="grid"
                        gridTemplateColumns="20% 80%"
                        gridGap={16}
                      >
                        <Box>
                          <Typography
                            variant="subtitle2"
                            style={{ marginTop: 16 }}
                          >
                            {translator(
                              useCostPrice ? translate.ISA_Cost : translate.ISA_TotalPrice,
                              useCostPrice ? "ต้นทุน" : "ราคารวม"
                            )}
                          </Typography>
                        </Box>
                        <Box>
                          {hidePriceByPermission ? (
                            <TextField
                              name="totalSum"
                              id="totalSum"
                              size="small"
                              variant="outlined"
                              fullWidth
                              value={translator(translate.ISA_NoPermissionToAccessData, "ไม่มีสิทธิ์เข้าถึงข้อมูล")}
                              disabled
                              InputProps={{
                                style: {
                                  backgroundColor: '#f5f5f5',
                                  color: '#9e9e9e',
                                  textAlign: 'right',
                                },
                              }}
                            />
                          ) : (
                            <NumberInput
                              name="totalSum"
                              id="totalSum"
                              value={totalSum}
                              textAlign="right"
                              readOnly
                            />
                          )}
                        </Box>
                      </Box>

                      <Box
                        mt={2}
                        display="grid"
                        gridTemplateColumns="20% 80%"
                        gridGap={16}
                      >
                        <Box>
                          <Typography
                            variant="subtitle2"
                            style={{ marginTop: 16 }}
                          >
                            {translator(translate.ISA_Remark, "หมายเหตุ")}
                          </Typography>
                        </Box>
                        <Box>
                          <TextField
                            name="remark"
                            id="remark"
                            size="small"
                            variant="outlined"
                            fullWidth
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                            disabled={isQuantityOnlyMode}
                          />
                        </Box>
                      </Box>

                      {isShowShipTo && (
                        <>
                          <Box
                            mt={2}
                            display="grid"
                            gridTemplateColumns="20% 80%"
                            gridGap={16}
                          >
                            <Box>
                              <Typography
                                variant="subtitle2"
                                style={{ marginTop: 16, fontWeight: "bold" }}
                              >
                                {translator(translate.ISA_ShipDate, "วันที่จัดส่ง")}
                              </Typography>
                            </Box>
                            <Box>
                              <KeyboardDatePicker
                                disableToolbar
                                disablePast={action === "add"}
                                inputVariant="outlined"
                                variant="inline"
                                format="DD/MM/YYYY"
                                mask="__/__/____"
                                margin="normal"
                                id="ship-date-picker"
                                emptyLabel=""
                                invalidDateMessage={translator(
                                  translate.ISA_InvalidShipDate,
                                  "วันที่จัดส่งไม่ถูกต้อง"
                                )}
                                value={shipDateSelected}
                                onChange={(date) =>
                                  handleDateChange(date, "ship")
                                }
                                disabled={isQuantityOnlyMode}
                                autoOk
                                fullWidth
                                KeyboardButtonProps={{
                                  "aria-label": "change date",
                                }}
                                inputProps={{
                                  readOnly: true,
                                }}
                              />
                              <Input
                                type="hidden"
                                name="shipToDate"
                                id="shipToDate"
                                value={shipDateSelected}
                                onChange={() => { }}
                              />
                            </Box>
                          </Box>

                          <Box
                            mt={2}
                            display="grid"
                            gridTemplateColumns="20% 80%"
                            gridGap={16}
                          >
                            <Box>
                              <Typography
                                variant="subtitle2"
                                style={{ marginTop: 16 }}
                              >
                                {translator(
                                  translate.ISA_Location,
                                  "สถานที่จัดส่ง"
                                )}
                              </Typography>
                            </Box>
                            <Box>
                              <SelectInput
                                name="shipTo"
                                id="shipTo"
                                value={shipToSelected}
                                onChange={setShipToSelected}
                                options={shipToList}
                                isClearable
                                isSearchable
                                isDisabled={isQuantityOnlyMode}
                              />
                            </Box>
                          </Box>
                        </>
                      )}
                    </>
                  )}

                  {isStockCount && (
                    <>
                      <Box
                        mt={2}
                        display="grid"
                        gridTemplateColumns="20% 80%"
                        gridGap={16}
                      >
                        <Box>
                          <Typography
                            variant="subtitle2"
                            style={{ marginTop: 16 }}
                          >
                            {translator(translate.ISA_Lot, "วันหมดอายุ")}{" "}
                            <span style={{ color: "red" }}> *</span>
                          </Typography>
                        </Box>
                        <Box>
                          <TextField
                            name="lotNo"
                            id="lotNo"
                            size="small"
                            variant="outlined"
                            fullWidth
                            value={lotNo}
                            onChange={(e) => setLotNo(e.target.value)}
                            disabled={isQuantityOnlyMode}
                          />
                        </Box>
                      </Box>

                      <Box
                        mt={2}
                        display="grid"
                        gridTemplateColumns="20% 80%"
                        gridGap={16}
                      >
                        <Box>
                          <Typography
                            variant="subtitle2"
                            style={{ marginTop: 16 }}
                          >
                            {translator(translate.ISA_MFGDate, "วันที่ผลิต")}{" "}
                            <span style={{ color: "red" }}> *</span>
                          </Typography>
                        </Box>
                        <Box>
                          <KeyboardDatePicker
                            disableToolbar
                            disablePast={false}
                            inputVariant="outlined"
                            variant="inline"
                            format="DD/MM/YYYY"
                            mask="__/__/____"
                            margin="normal"
                            id="mfg-date-picker"
                            emptyLabel=""
                            invalidDateMessage={translator(
                              translate.ISA_InvalidMFGDate,
                              "วันที่ผลิตไม่ถูกต้อง"
                            )}
                            value={mfgDateSelected}
                            onChange={(date) => handleDateChange(date, "mfg")}
                            disabled={isQuantityOnlyMode}
                            autoOk
                            fullWidth
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            inputProps={{
                              readOnly: true,
                            }}
                          />
                          <Input
                            type="hidden"
                            name="mfgDate"
                            id="mfgDate"
                            value={mfgDateSelected}
                            onChange={() => { }}
                          />
                          {/* <FormFeedback>กรุณากรอกวันที่เริ่มเข้าเยี่ยม</FormFeedback> */}
                        </Box>
                      </Box>

                      <Box
                        mt={2}
                        display="grid"
                        gridTemplateColumns="20% 80%"
                        gridGap={16}
                      >
                        <Box>
                          <Typography
                            variant="subtitle2"
                            style={{ marginTop: 16 }}
                          >
                            {translator(translate.ISA_EXPDate, "วันหมดอายุ")}{" "}
                            <span style={{ color: "red" }}> *</span>
                          </Typography>
                        </Box>
                        <Box>
                          <KeyboardDatePicker
                            disableToolbar
                            disablePast={false}
                            inputVariant="outlined"
                            variant="inline"
                            format="DD/MM/YYYY"
                            mask="__/__/____"
                            margin="normal"
                            id="exp-date-picker"
                            emptyLabel=""
                            invalidDateMessage={translator(
                              translate.ISA_InvalidEXPDate,
                              "วันหมดอายุไม่ถูกต้อง"
                            )}
                            value={expDateSelected}
                            onChange={(date) => handleDateChange(date, "exp")}
                            disabled={isQuantityOnlyMode}
                            autoOk
                            fullWidth
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            inputProps={{
                              readOnly: true,
                            }}
                          />
                          <Input
                            type="hidden"
                            name="expDate"
                            id="expDate"
                            value={expDateSelected}
                            onChange={() => { }}
                          />
                          {/* <FormFeedback>กรุณากรอกวันที่เริ่มเข้าเยี่ยม</FormFeedback> */}
                        </Box>
                      </Box>
                    </>
                  )}

                  {(isShowWarehouse || isShowSRECNumber) && (
                    <Box
                      mt={2}
                      display="grid"
                      gridTemplateColumns="20% 80%"
                      gridGap={16}
                    >
                      <Box>
                        <Typography
                          variant="subtitle2"
                          style={{ marginTop: 16 }}
                        >
                          {translator(translate.ISA_Warehouse, "คลังสินค้า")}
                          <span style={{ color: "red" }}> *</span>
                        </Typography>
                      </Box>
                      <Box>
                        <SelectInput
                          id="warehouse"
                          name="warehouse"
                          value={warehouseSelected}
                          onChange={(selected) => {
                            setWarehouseSelected(selected);
                            // เรียก fetchWarehouseLocationList ด้วย plantNo ที่เลือก
                            if (selected && selected.value) {
                              // ต้องส่ง plantNo ไปด้วยเพราะ state ยังไม่อัพเดท
                              fetchWarehouseLocationListByPlantNo(
                                selected.value
                              );
                            } else {
                              setWhsLocationList([]);
                              setWhsLocationSelected("");
                            }
                          }}
                          options={warehouseList}
                          isClearable
                          isSearchable
                          isDisabled={isQuantityOnlyMode}
                        />
                      </Box>
                    </Box>
                  )}

                  {(isShowWhsLocation || isShowSRECNumber) && (
                    <Box
                      mt={2}
                      display="grid"
                      gridTemplateColumns="20% 80%"
                      gridGap={16}
                    >
                      <Box>
                        <Typography
                          variant="subtitle2"
                          style={{ marginTop: 16 }}
                        >
                          {translator(
                            translate.ISA_WarehouseLocation,
                            "ตำแหน่งคลังสินค้า"
                          )}
                          <span style={{ color: "red" }}> *</span>
                        </Typography>
                      </Box>
                      <Box>
                        <SelectInput
                          id="whsLocation"
                          name="whsLocation"
                          value={whsLocationSelected}
                          onChange={setWhsLocationSelected}
                          options={whsLocationList}
                          isClearable
                          isSearchable
                          isDisabled={isQuantityOnlyMode}
                        />
                      </Box>
                    </Box>
                  )}

                  {isShowSRECNumber &&
                    <Box
                      mt={2}
                      display="grid"
                      gridTemplateColumns="20% 80%"
                      gridGap={16}
                    >
                      <Box>
                        <Typography
                          variant="subtitle2"
                          style={{ marginTop: 16 }}
                        >
                          {translator(translate.ISA_SRECNumber, "อ้างอิง SREC")}
                        </Typography>
                      </Box>
                      <Box>
                        <TextField
                          name="supplierReceiveRef"
                          id="supplierReceiveRef"
                          size="small"
                          variant="outlined"
                          fullWidth
                          value={supplierReceiveRef}
                          onChange={(e) => setSupplierReceiveRef(e.target.value)}
                          disabled={true}
                        />
                      </Box>
                    </Box>
                  }

                  {isShowSupInvNumber && docType !== 'DOC_SPO' && docType !== 'DOC_SPR' &&
                    <Box
                      mt={2}
                      display="grid"
                      gridTemplateColumns="20% 80%"
                      gridGap={16}
                    >
                      <Box>
                        <Typography
                          variant="subtitle2"
                          style={{ marginTop: 16 }}
                        >
                          {translator(
                            translate.ISA_SupInvNumber,
                            "เลขที่ Sup Invoice"
                          )}
                          <span style={{ color: "red" }}> *</span>
                        </Typography>
                      </Box>
                      <Box>
                        <TextField
                          name="supInvNumber"
                          id="supInvNumber"
                          size="small"
                          variant="outlined"
                          fullWidth
                          value={invNumber}
                          onChange={(e) => setInvNumber(e.target.value)}
                          disabled={isQuantityOnlyMode || defaultSupInvoiceRef}
                        />
                      </Box>
                    </Box>
                  }

                  {isShowPONumber && (
                    <Box
                      mt={2}
                      display="grid"
                      gridTemplateColumns="20% 80%"
                      gridGap={16}
                    >
                      <Box>
                        <Typography
                          variant="subtitle2"
                          style={{ marginTop: 16 }}
                        >
                          {translator(translate.ISA_PONumber, "อ้างอิง PO")}
                        </Typography>
                      </Box>
                      <Box>
                        <TextField
                          name="poNumber"
                          id="poNumber"
                          size="small"
                          variant="outlined"
                          fullWidth
                          value={poNumber}
                          onChange={(e) => setPoNumber(e.target.value)}
                          // disabled={action === 'edit'} // ปิดการแก้ไขในโหมด Edit
                          disabled={true}
                        />
                      </Box>
                    </Box>
                  )}

                  {isShowInvNumber &&
                    <Box
                      mt={2}
                      display="grid"
                      gridTemplateColumns="20% 80%"
                      gridGap={16}
                    >
                      <Box>
                        <Typography
                          variant="subtitle2"
                          style={{ marginTop: 16 }}
                        >
                          {translator(translate.ISA_InvNumber, "เลขที่ Invoice")}
                          <span style={{ color: "red" }}> *</span>
                        </Typography>
                      </Box>
                      <Box>
                        <TextField
                          name="invNumber"
                          id="invNumber"
                          size="small"
                          variant="outlined"
                          fullWidth
                          value={invNumber}
                          disabled={true}
                        />
                      </Box>
                    </Box>
                  }

                  {isShowInvDate && (
                    <Box
                      mt={2}
                      display="grid"
                      gridTemplateColumns="20% 80%"
                      gridGap={16}
                    >
                      <Box>
                        <Typography
                          variant="subtitle2"
                          style={{ marginTop: 16 }}
                        >
                          {translator(translate.ISA_InvDate, "วันที่ Invoice")}{" "}
                          <span style={{ color: "red" }}> *</span>
                        </Typography>
                      </Box>
                      <Box>
                        <KeyboardDatePicker
                          disableToolbar
                          disablePast={false}
                          inputVariant="outlined"
                          variant="inline"
                          format="DD/MM/YYYY"
                          mask="__/__/____"
                          margin="normal"
                          id="inv-date-picker"
                          emptyLabel=""
                          value={invDateSelected}
                          disabled={true}
                          autoOk
                          fullWidth
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                            disabled: true,
                          }}
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </Box>
                    </Box>
                  )}

                  {/* ส่วนลดระดับรายการ - ซ่อนถ้าเป็นสินค้าแถม หรือไม่มีสิทธิ์ดูตัวเลขเงิน */}
                  {!isFreeItem && isShowDiscount && !hidePriceByPermission && (
                    <>
                      <Box mt={7} display="grid" gridGap={16}>
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                          <MainButton
                            label={translator(
                              translate.ISA_AddSequence,
                              "เพิ่มส่วนลด"
                            )}
                            handleClick={handleOpenDiscountDialog}
                          />
                        </Box>
                        <Box>
                          <DiscountList
                            discounts={discounts}
                            onEdit={(discount) =>
                              handleOpenDiscountDialogForEdit(discount)
                            }
                            onDelete={handleDeleteDiscount}
                          />
                        </Box>
                      </Box>

                      <Box
                        mt={5}
                        display="grid"
                        gridTemplateColumns="20% 80%"
                        gridGap={16}
                      >
                        <Box>
                          <Typography
                            variant="subtitle2"
                            style={{ marginTop: 16 }}
                          >
                            {translator(translate.ISA_Discount, "ส่วนลด")}
                          </Typography>
                        </Box>
                        <Box>
                          {docType === "DOC_ORDER" && hidePriceByPermission ? (
                            <TextField
                              id="totalDiscount"
                              name="totalDiscount"
                              size="small"
                              variant="outlined"
                              fullWidth
                              value={translator(translate.ISA_NoPermissionToAccessData, "ไม่มีสิทธิ์เข้าถึงข้อมูล")}
                              disabled
                              InputProps={{
                                style: {
                                  backgroundColor: '#f5f5f5',
                                  color: '#9e9e9e',
                                  textAlign: 'right',
                                },
                              }}
                            />
                          ) : (
                            <NumberInput
                              id="totalDiscount"
                              name="totalDiscount"
                              value={totalDiscount}
                              textAlign="right"
                              readOnly
                            />
                          )}
                        </Box>
                      </Box>

                      <Box
                        mt={2}
                        display="grid"
                        gridTemplateColumns="20% 80%"
                        gridGap={16}
                      >
                        <Box>
                          <Typography
                            variant="subtitle2"
                            style={{ marginTop: 16 }}
                          >
                            {translator(translate.ISA_Net, "ยอดสุทธิ")}
                          </Typography>
                        </Box>
                        <Box>
                          {docType === "DOC_ORDER" && hidePriceByPermission ? (
                            <TextField
                              id="grandTotal"
                              name="grandTotal"
                              size="small"
                              variant="outlined"
                              fullWidth
                              value={translator(translate.ISA_NoPermissionToAccessData, "ไม่มีสิทธิ์เข้าถึงข้อมูล")}
                              disabled
                              InputProps={{
                                style: {
                                  backgroundColor: '#f5f5f5',
                                  color: '#9e9e9e',
                                  textAlign: 'right',
                                },
                              }}
                            />
                          ) : (
                            <NumberInput
                              id="grandTotal"
                              name="grandTotal"
                              value={grandTotal}
                              textAlign="right"
                              readOnly
                            />
                          )}
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
              ) : isInitialLoading ? (
                <Box
                  p={3}
                  textAlign="center"
                  style={{ minHeight: 400 }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Box>
                    <CircularProgress size={60} style={{ color: "#ff6f00" }} />
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      style={{ marginTop: 16 }}
                    >
                      {translator(translate.ISA_LoadingProductData, "กำลังโหลดข้อมูลสินค้า...")}
                    </Typography>
                  </Box>
                </Box>
              ) : (
                <Box
                  p={3}
                  textAlign="center"
                  border="2px dashed #ccc"
                  borderRadius={2}
                  bgcolor="#f9f9f9"
                >
                  <Typography variant="h6" color="textSecondary" gutterBottom>
                    {translator(
                      translate.ISA_PleaseSelectProduct,
                      "กรุณาเลือกสินค้าก่อน"
                    )}
                  </Typography>
                </Box>
              )}
            </div>
          </div>

          {/* Sticky Action Bar */}
          <StickyActionBar>
            <MainButton
              label={translator(translate.ISA_Cancel1, "ยกเลิก")}
              color={"bg-red"}
              handleClick={() => onCloseDialog(null)}
              disabled={loading}
            />

            <MainButton
              label={translator(
                translate.ISA_Button_SubmitForm,
                "บันทึกรายการ"
              )}
              handleClick={() => handleSubmit()}
              disabled={loading}
            />
          </StickyActionBar>
        </DialogContent>
      </Dialog>

      {/* Dialog สำหรับเพิ่มส่วนลด */}
      {openDiscountDialog && productSelected && (
        <DialogProductDiscountForm
          open={openDiscountDialog}
          action={discountAction}
          editData={editDiscountData}
          product={productSelected}
          discountLevel="L"
          existingDiscounts={discounts}
          onCloseDialog={handleCloseDiscountDialog}
        />
      )}

      {/* Dialog สำหรับเช็คสต็อก */}
      {openCheckStockDialog && productSelected && (
        <DialogCheckStock
          open={openCheckStockDialog}
          product={productSelected}
          onClose={() => setOpenCheckStockDialog(false)}
        />
      )}

      {/* Dialog สำหรับเช็คราคา */}
      {openCheckPriceDialog && productSelected && (
        <DialogCheckPrice
          open={openCheckPriceDialog}
          product={productSelected}
          customer={customer}
          onClose={() => setOpenCheckPriceDialog(false)}
        />
      )}
    </>
  );
};

export default DialogProductSelectorForm;
